import { useRef } from "react";

const useApiCancellation = () => {
  const abortControllerRef = useRef(null);

  const cancelRequest = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };

  const createNewController = () => {
    const controller = new AbortController();
    abortControllerRef.current = controller;
    return controller;
  };

  return { cancelRequest, createNewController };
};

export default useApiCancellation;
